<template>
  <right-menu-item
    :href="selectedLink"
    :class="{'muted': !show}"
    mode="ajax"
    :text="$t('Edit user')"
    icon="pen"
    icon-class=""
  />
</template>

<script>
import {mapStores} from 'pinia'
import useBcSelectedStore from '@/frontapp/store/bcSelected'

export default {
  computed: {
    show () {
      return this.bcSelectedStore.listSelected.length == 1
    },
    selectedLink() {
      if (this.bcSelectedStore.listSelected.length == 1) {
        return this.bcSelectedStore.listSelected[0]._rowActions.editlink
      }
      return '#';
    },
    ...mapStores(useBcSelectedStore),
  },
}
</script>

<style lang="scss" scoped></style>
